import {createTheme} from '@mui/material/styles'

export const primaryColor = '#0060ad'
export const secondaryColor = '#16bae7'

export const defaultTheme = createTheme({
    palette: {
        primary: {main: primaryColor},
        secondary: {main: secondaryColor},
        info: {main: primaryColor, light: '#B4E2F5'}
    },
    components: {
        MuiTextField: {
            defaultProps: {
                variant: 'standard'
            }
        }
    }
})
